import EfImg from '@elem/ui/ef-img';
import EcoSpace from 'eco-design/base/eco-space';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function SectionListGraph() {
    const { t } = useLang('SectionListGraph');

    const items = [
        {
            text1: t('grid1_text'),
            text2: t('grid1_text2'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1748139400504/grass.jpg',
            imgh5: 'https://websiteoss.ecoflow.com/upload/image/1748140026682/grass_h5.jpg',
        },
        {
            text1: t('grid2_text'),
            text2: t('grid2_text2'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1748140043284/cement.jpg',
            imgh5: 'https://websiteoss.ecoflow.com/upload/image/1748140045798/cement_h5.jpg',
        },
        {
            text1: t('grid3_text'),
            text2: t('grid3_text2'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1748140062011/sandy.jpg',
            imgh5: 'https://websiteoss.ecoflow.com/upload/image/1748140064833/sandy_h5.jpg',
        },
        {
            text1: t('grid4_text'),
            text2: t('grid4_text2'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1748140088171/snow.jpg',
            imgh5: 'https://websiteoss.ecoflow.com/upload/image/1748140091248/snow_h5.jpg',
        },
        {
            text1: t('grid5_text'),
            text2: t('grid5_text2'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1748140114968/mirror.jpg',
            imgh5: 'https://websiteoss.ecoflow.com/upload/image/1748140117400/mirror_h5.jpg',
        },
    ];

    return (
        <div className={styles.SectionListGraph}>
            <EcoSpace hPc="160px" hPad="100px" hH5="100px" />
            <div className="eco-section-common">
                <div className="eco-section">
                    <div className="eco-section-title">{t('title')}</div>
                    <div className="eco-section-desc">{t('desc')}</div>
                </div>
            </div>
            <div className="eco-content">
                <div className="sgl-grid">
                    {items.map((item, index) => (
                        <div className="grid-item" key={index}>
                            <EfImg className="item-img" pc={item.img} h5={item.imgh5} />
                            <div className="sgl-text">
                                <div className="text1">{item.text1}</div>
                                <div className="text2">{item.text2}</div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="sgl-img">
                    <EfImg
                        pc={'https://websiteoss.ecoflow.com/upload/image/1748078335415/panel.jpg'}
                        pad={'https://websiteoss.ecoflow.com/upload/image/1748078335415/panel.jpg'}
                        h5={'https://websiteoss.ecoflow.com/upload/image/1748140443554/panel_h5.jpg'}
                    />
                </div>
            </div>
        </div>
    );
}
